import React from 'react'
import { useSiteContext, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { FooterAccountSignup } from './footer-account-signup'

const FooterAccountSignupClient = () => {
  const { siteUrl } = useSiteContext()
  const { translate } = useTranslations()
  return <FooterAccountSignup siteUrl={siteUrl} translate={translate} />
}
export default FooterAccountSignupClient
